import { cloneDeep, isNil } from 'lodash';

import { safelyExtractTextFromHTML, VRCAudioMetadata } from '@pwp-common';

import { AudioFilesEditorOutput, SSMLAudio } from '../audio-files-editor-output';
import { defaultAudioFilesEditorOutput } from '../default-audio-files';

export const dbToAudioFilesEditorOutput = (params: {
  vrcAudioMetadata: VRCAudioMetadata;
  currentLanguage: string;
  availableLanguages: string[];
}): AudioFilesEditorOutput => {
  /**
   * Handle empty input
   */
  if (isNil(params) || isNil(params.vrcAudioMetadata)) {
    return cloneDeep(defaultAudioFilesEditorOutput);
  }

  const audioMap = params.vrcAudioMetadata.getAudio();
  const audioByLanguage: Record<string, SSMLAudio> = {};

  for (const languageCode of params.availableLanguages) {
    const dbAudio = audioMap.get(languageCode);
    const strippedSSML = safelyExtractTextFromHTML(dbAudio?.getSSML());

    audioByLanguage[languageCode] = {
      ssml: strippedSSML,
      selectedFile: undefined,
    };
  }

  const result: AudioFilesEditorOutput = {
    displayName: params.vrcAudioMetadata.getDisplayName(),
    currentLanguage: params.currentLanguage,
    audioByLanguage,
  };

  return result;
};
